/* eslint-disable no-underscore-dangle */
import ListingPage from '@app/common/ListingPage';
import { parseUrl } from '@helpers/algolia/ruleContext';
import { DYNAMIC_GUIDE_SECTION_KEYS } from '@helpers/constants/guideshop';
import parseAlgoliaFilters from '@helpers/datocms/algoliaFilters';
import { fetchIndexFacets, getAlgoliaClientLite, getProductsFromAlgolia } from '@services/algolia';
import getProductsFromAlgoliaByFilter from '@services/algolia/getProductsFromAlgoliaByFilter';
import {
  formatFacetsConfig,
  formatRuleContext,
  formatStringConditions,
  formatTaxonomyFilters,
  formatTaxonomyIndex,
  formatTaxonomyQuery,
  formatVisualFilters,
  parseTaxonomyFilters,
} from '@services/datocms/helpers/taxonomy';
import getAllGuides from '@services/guide-shop/getAllGuides';
import { groupStoresByState } from '@utils/guideshop';
import { gql } from 'graphql-request';
import { findResultsState } from 'react-instantsearch-dom/server';
import { TProduct } from 'types/product';
import { HERO_CAROUSEL_SLIDES_MAX, parseHomePageConfig } from '../home/parseHomePageConfig';
import { getServerlessFixedAndDefaultFiltersData } from '../search/getFixedAndDefaultFilters';
import { TSectionAlertData, sectionAlertDataGql } from './sectionAlert';
import { TAnchorButtonData, anchorButtonDataGql } from './sectionAnchorButton';
import { TSectionBannerBlock, sectionBannerBlockDataGql } from './sectionBannerBlock';
import { TSectionBannerDefaultData, sectionBannerDefaultDataGql } from './sectionBannerDefault';
import { TSectionBannerImageData, sectionBannerImageDataGql } from './sectionBannerImage';
import { TSectionCardPressData, sectionCardPressDataGql } from './sectionCardPress';
import { TSectionCarouselData, sectionCarouselDataGql } from './sectionCarousel';
import { TSectionCategoriesData, sectionCategoriesDataGql } from './sectionCategories';
import { TSectionCategoriesB2BData, sectionCategoriesB2BDataGql } from './sectionCategoriesB2B';
import {
  TSectionCategoriesChipsData,
  sectionCategoriesChipsDataGql,
} from './sectionCategoriesChips';
import { TSectionCategoriesGridData, sectionCategoriesGridDataGql } from './sectionCategoriesGrid';
import {
  TSectionCategoriesHighlightedRecordData,
  sectionCategoriesHighlightedRecordDataGql,
} from './sectionCategoriesHighlighted';
import {
  TSectionCategoriesShowcaseData,
  sectionCategoriesShowcaseDataGql,
} from './sectionCategoriesShowcase';
import { TSectionCategoryMosaicData, sectionCategoryMosaicDataGql } from './sectionCategoryMosaic';
import { TSectionDescriptionData, sectionDescriptionDataGql } from './sectionDescription';
import { TSectionDoubleBannerData, sectionDoubleBannerDataGql } from './sectionDoubleBanner';
import { TSectionFaqData, sectionFaqDataGql } from './sectionFaq';
import { TSectionFeatureContentData, sectionFeatureContentDataGql } from './sectionFeatureContent';
import { TSectionFeatureData, sectionFeaturesDataGql } from './sectionFeatures';
import { TSectionFeatureDataB2B, sectionFeaturesDataGqlB2B } from './sectionFeaturesB2B';
import { TSectionFeatureGridData, sectionFeaturesGridDataGql } from './sectionFeaturesGrid';
import { TSectionFormData, sectionFormDataGql } from './sectionForm';
import { TSectionGridImagesData, sectionGridImagesDataGql } from './sectionGridImages';
import {
  TSectionGuideAllStoresListData,
  sectionGuideAllStoresListDataGql,
} from './sectionGuideAllStoresList';
import { TSectionGuideSearchData, sectionGuideSearchDataGql } from './sectionGuideSearch';

import {
  TSectionBannerDefaultNewData,
  sectionBannerDefaultNewDataGql,
} from './sectionBannerDefaultNew';
import { TSectionBannersCarouselData, sectionBannersCarouselGql } from './sectionBannersCarousel';
import { TSectionBlogData, sectionBlogDataGql } from './sectionBlog';
import { TSectionBrandBanner, sectionBrandBannerDataGql } from './sectionBrandBanner';
import { TSectionBrandCardData, sectionBrandCardDataGql } from './sectionBrandCard';
import { TSectionCalculatorData, sectionCalculatorDataGql } from './sectionCalculator';
import {
  TSectionCardsDivulgationData,
  sectionCardsDivulgationDataGql,
} from './sectionCardsDivulgation';
import { TSectionContactCardData, sectionContactCardDataGql } from './sectionContactCard';
import { TSectionCouponsNewData, sectionCouponsNewDataGql } from './sectionCouponsNew';
import {
  TSectionDefaultAndContactCardData,
  sectionDefaultAndContactCardDataGql,
} from './sectionDefaultAndContactCard';
import { TSectionDefaultBanner, sectionDefaultBannerDataGql } from './sectionDefaultBanner';
import { TSectionDefaultCardData, sectionDefaultCardDataGql } from './sectionDefaultCard';
import { TSectionFeatureCardData, sectionFeatureCardDataGql } from './sectionFeatureCard';
import { sectionGalleryCardDataGql } from './sectionGalleryCard';
import {
  TSectionGalleryCardChipData,
  sectionGalleryCardChipDataGql,
} from './sectionGalleryCardChip';
import {
  TSectionGalleryInteractiveData,
  sectionGalleryInteractiveDataGql,
} from './sectionGalleryInteractive';
import {
  TSectionGridDescriptiveData,
  sectioGridDescriptiveDataGql,
} from './sectionGridDescriptive';
import {
  TSectionHighlightBannerData,
  sectionHighlightBannerDataGql,
} from './sectionHighlightBanner';
import { TSectionHighlightCard, sectionHighlightCardDataGql } from './sectionHighlightCard';
import { sectionInlineBannerDataGql } from './sectionInlineBanner';
import { TSectionLittleClockData, sectionLittleClockDataGql } from './sectionLittleClock';
import { TSectionLoginData, sectionLoginDataGql } from './sectionLogin';
import { TSectionLogosShowcaseData, sectionLogosShowcaseDataGql } from './sectionLogosShowcase';
import { TSectionMultipleCtaData, sectionMultipleCtaDataGql } from './sectionMultipleCta';
import { TSectionNewsletterData, sectionNewsletterDataGql } from './sectionNewsletter';
import { TSectionNewsletterB2BData, sectionNewsletterB2BDataGql } from './sectionNewsletterB2B';
import { TSectionProductListingData, sectionProductListingDataGql } from './sectionProductListing';
import {
  TSectionProductShowcaseData,
  sectionProductShowcaseDataGql,
} from './sectionProductShowcase';
import { TSectionPromotionalBannerData, sectionPromotionalDataGql } from './sectionPromotional';
import { TSectionReviewData, sectionReviewGqlDataGql } from './sectionReview';
import {
  TSectionReviewCarouselData,
  sectionReviewCarouselDataGql,
} from './sectionReviewCarouselGql';
import { TSectionRibbonBannerData, sectionRibbonBannerDataGql } from './sectionRibbonBanner';
import { TSectionSearchHeaderData, sectionSearchHeaderDataGql } from './sectionSearchHeader';
import { TSectionSeoTextData, sectionSeoTextDataGql } from './sectionSeoText';
import {
  TSectionServiceEvaluation,
  sectionServiceEvaluationDataGql,
} from './sectionServiceEvaluation';
import { TSectionServiceListData, sectionServiceListDataGql } from './sectionServiceList';
import {
  TSectionServiceStepGuide,
  sectionServiceStepGuideDataGql,
} from './sectionServiceStepGuide';
import { TSectionSingleCtaData, sectionSingleCtaDataGql } from './sectionSingleCta';
import { TSectionStepData, sectionStepsDataGql } from './sectionSteps';
import { TSectionTestemonial, sectionTestemonialDataGql } from './sectionTestemonial';
import { TSectionTextData, sectionTextDataGql } from './sectionText';
import { TSectionBannerTextData, sectionTextBannerDataGql } from './sectionTextBanner';
import { TSectionTripleBannerData, sectionTripleBannerDataGql } from './sectionTripleBanner';
import {
  TSectionTripleDescriptiveGridData,
  sectionTripleDescriptiveGridDataGql,
} from './sectionTripleDescriptiveGrid';
import {
  TSectionTripleDescriptiveGridVariantData,
  sectionTripleDescriptiveGridVariantDataGql,
} from './sectionTripleDescriptiveGridVariant';
import { TSectionVideoBanner, sectionVideoBannerDataGql } from './sectionVideoBanner';
import { TSectionVideoPartnersData, sectionVideoPartnersDataGql } from './sectionVideoPartners';
import { TSectionVideoPlayerData, sectionVideoPlayerDataGql } from './sectionVideoPlayer';
import { TSectionVideoData, sectionVideosDataGql } from './sectionVideos';
import {
  TSectionWishlistShowcase,
  sectionWishlistShowcaseDataGql,
} from './sectionWishlistShowcase';

export type TSections = (
  | TSectionCarouselData
  | TSectionCategoriesData
  | TSectionCategoriesB2BData
  | TSectionCategoriesHighlightedRecordData
  | TSectionDoubleBannerData
  | TSectionMultipleCtaData
  | TSectionNewsletterData
  | TSectionNewsletterB2BData
  | TSectionProductShowcaseData
  | TSectionRibbonBannerData
  | TSectionSingleCtaData
  | TSectionTripleBannerData
  | TSectionTripleDescriptiveGridData
  | TSectionGridDescriptiveData
  | TSectionTextData
  | TSectionBannerDefaultData
  | TSectionBannerDefaultNewData
  | TSectionFormData
  | TAnchorButtonData
  | TSectionBannerImageData
  | TSectionDescriptionData
  | TSectionFeatureData
  | TSectionCouponsNewData
  | TSectionCardPressData
  | TSectionVideoData
  | TSectionFaqData
  | TSectionProductListingData
  | TSectionTestemonial
  | TSectionFeatureDataB2B
  | TSectionFeatureGridData
  | TSectionFeatureContentData
  | TSectionCategoryMosaicData
  | TSectionCategoriesGridData
  | TSectionAlertData
  | TSectionCategoriesShowcaseData
  | TSectionBannerBlock
  | TSectionGridImagesData
  | TSectionSeoTextData
  | TSectionCategoriesChipsData
  | TSectionSearchHeaderData
  | TSectionLogosShowcaseData
  | TSectionHighlightBannerData
  | TSectionStepData
  | TSectionLoginData
  | TSectionLittleClockData
  | TSectionReviewData
  | TSectionBannerTextData
  | TSectionGalleryInteractiveData
  | TSectionHighlightCard
  | TSectionDefaultCardData
  | TSectionWishlistShowcase
  | TSectionPromotionalBannerData
  | TSectionCardsDivulgationData
  | TSectionBannersCarouselData
  | TSectionBlogData
  | TSectionServiceListData
  | TSectionServiceStepGuide
  | TSectionServiceEvaluation
  | TSectionBrandBanner
  | TSectionDefaultBanner
  | TSectionVideoBanner
  | TSectionBrandCardData
  | TSectionDefaultAndContactCardData
  | TSectionVideoPlayerData
  | TSectionFeatureCardData
  | TSectionContactCardData
  | TSectionGalleryCardChipData
  | TSectionVideoPartnersData
  | TSectionTripleDescriptiveGridVariantData
  | TSectionReviewCarouselData
  | TSectionCalculatorData
  | TSectionGuideSearchData
  | TSectionGuideAllStoresListData
  | any
)[];

export const allSectionsGql = (hasB2BSections = true): string => {
  const b2bQuery = `
    ${sectionCategoriesB2BDataGql}
    ${sectionNewsletterB2BDataGql}
    ${sectionFeaturesDataGqlB2B}
  `;

  const b2bSections = hasB2BSections ? b2bQuery : '';

  return gql`
    ${sectionCarouselDataGql}
    ${sectionCategoriesDataGql}
    ${sectionCategoryMosaicDataGql}
    ${sectionCategoriesHighlightedRecordDataGql}
    ${sectionDoubleBannerDataGql}
    ${sectionMultipleCtaDataGql}
    ${sectionNewsletterDataGql}
    ${sectionProductShowcaseDataGql}
    ${sectionRibbonBannerDataGql}
    ${sectionSingleCtaDataGql}
    ${sectionTripleBannerDataGql}
    ${sectionTripleDescriptiveGridDataGql}
    ${sectioGridDescriptiveDataGql}
    ${sectionTextDataGql}
    ${sectionBannerDefaultDataGql}
    ${sectionBannerDefaultNewDataGql}
    ${sectionFormDataGql}
    ${anchorButtonDataGql}
    ${sectionBannerImageDataGql}
    ${sectionDescriptionDataGql}
    ${sectionFeaturesDataGql}
    ${sectionCouponsNewDataGql}
    ${sectionCardPressDataGql}
    ${sectionVideosDataGql}
    ${sectionFaqDataGql}
    ${sectionProductListingDataGql}
    ${sectionTestemonialDataGql}
    ${sectionFeaturesGridDataGql}
    ${sectionFeatureContentDataGql}
    ${sectionCategoriesGridDataGql}
    ${sectionAlertDataGql}
    ${sectionCategoriesShowcaseDataGql}
    ${sectionBannerBlockDataGql}
    ${sectionGridImagesDataGql}
    ${sectionSeoTextDataGql}
    ${sectionStepsDataGql}
    ${sectionCategoriesChipsDataGql}
    ${sectionSearchHeaderDataGql}
    ${sectionLogosShowcaseDataGql}
    ${sectionHighlightBannerDataGql}
    ${sectionHighlightCardDataGql}
    ${b2bSections}
    ${sectionLoginDataGql}
    ${sectionLittleClockDataGql}
    ${sectionReviewGqlDataGql}
    ${sectionTextBannerDataGql}
    ${sectionGalleryCardDataGql}
    ${sectionGalleryInteractiveDataGql}
    ${sectionDefaultCardDataGql}
    ${sectionWishlistShowcaseDataGql}
    ${sectionPromotionalDataGql}
    ${sectionCardsDivulgationDataGql}
    ${sectionBannersCarouselGql}
    ${sectionBlogDataGql}
    ${sectionServiceListDataGql}
    ${sectionServiceStepGuideDataGql}
    ${sectionServiceEvaluationDataGql}
    ${sectionBrandBannerDataGql}
    ${sectionDefaultBannerDataGql}
    ${sectionVideoBannerDataGql}
    ${sectionBrandCardDataGql}
    ${sectionVideoPlayerDataGql}
    ${sectionDefaultAndContactCardDataGql}
    ${sectionInlineBannerDataGql}
    ${sectionContactCardDataGql}
    ${sectionFeatureCardDataGql}
    ${sectionGalleryCardChipDataGql}
    ${sectionBannerDefaultDataGql}
    ${sectionVideoPartnersDataGql}
    ${sectionTripleDescriptiveGridVariantDataGql}
    ${sectionReviewCarouselDataGql}
    ${sectionCalculatorDataGql}
    ${sectionGuideSearchDataGql}
    ${sectionGuideAllStoresListDataGql}
  `;
};

type TTaxonomyConfig = {
  taxonomyUrl?: string;
  taxonomyName?: string;
  breadcrumb?: any[];
};

type TParseSections = {
  sections: TSections;
  taxonomy?: TTaxonomyConfig;
  heroCarouselConfig?: number;
  channel?: string;
  sectionsConfig?: Record<string, any>;
};

const parseProductListing = async ({
  section,
  breadcrumb,
  taxonomyName,
  taxonomyUrl,
  prevVal2,
  fixedAndDefaultFilter,
}) => {
  const searchClient = getAlgoliaClientLite();
  const index = formatTaxonomyIndex(section.content[0].contentType);
  const allFacets = await fetchIndexFacets(index);
  const ruleContexts = formatRuleContext(section.content[0].contentType);

  const filters = formatTaxonomyFilters(section?.content[0]?.taxonomyFilter || []);
  const visualFilters = formatVisualFilters(section?.content[0]?.visualFilterConfig || []);
  const stepFilter = section?.content[0]?.categoryStepsFilter
    ? parseAlgoliaFilters(section?.content[0]?.categoryStepsFilter[0]?.options)
    : [];
  const stepsOption = section?.content[0]?.categoryStepsFilter || [];
  const query = formatTaxonomyQuery(section?.content[0]?.taxonomyFilter || []);
  const facetsConfig = formatFacetsConfig(
    section?.content[0]?.categoryAlgoliaFilters,
    fixedAndDefaultFilter
  );
  const sectionTaxonomy = {
    name: taxonomyName,
    filters,
    visualFilters,
    query,
    facetsConfig,
    stepFilter,
    stepsOption,
  };

  if (taxonomyUrl) {
    const { context, contextWithType } = parseUrl(taxonomyUrl);
    ruleContexts.push(context, contextWithType);
  }

  const resultsState = await findResultsState(ListingPage, {
    searchClient,
    indexName: index,
    allFacets,
    ruleContexts,
    breadcrumb,
    showBreadcrumb: breadcrumb.length > 0,
    cmsConfig: section.content[0].productCard,
    title: taxonomyName,
    taxonomy: sectionTaxonomy,
  });

  return [
    ...prevVal2,
    {
      ...section,
      config: {
        index,
        allFacets,
        ruleContexts,
        resultsState: JSON.parse(JSON.stringify(resultsState)),
        emptyResults: resultsState?.rawResults?.[0]?.nbHits === 0,
        filters,
        breadcrumb,
        taxonomy: sectionTaxonomy,
        showTitle: section.content[0].showListingTitle,
        showProductCount: section.content[0].showProductCount,
      },
    },
  ];
};

const parseProductsShowcase = async (section, sectionsConfig) => {
  let productsShowcase = [] as TProduct[];
  const { populateProducts = true } = sectionsConfig?.section_showcase || {};

  if (section?.taxonomyFilter?.length === 0) {
    if (populateProducts) {
      const productIdsShowcase = section.produtos.map(product => product.productId);
      productsShowcase = await getProductsFromAlgolia(productIdsShowcase);
    }
  } else {
    const isSku = section?.taxonomyFilter.some(filter =>
      filter.filterType.includes('algolia_filter_sku')
    );
    const filters = formatTaxonomyFilters(section?.taxonomyFilter || []);
    if (isSku) {
      const filtersSku = filters.filter(({ filterOperator }) => filterOperator === 'SKU');
      const arrayConditionSku = filtersSku
        .reduce(
          (prevValConditions, { arrayConditions }) => [...prevValConditions, ...arrayConditions],
          []
        )
        .map(item => item.replace('objectID:', ''));
      const products = await getProductsFromAlgolia(arrayConditionSku);
      productsShowcase = products.slice(0, section?.quantity);
    } else {
      const stringCondition = formatStringConditions({ filters });
      productsShowcase = await getProductsFromAlgoliaByFilter({
        facetFilters: [],
        searchOptions: {
          filters: stringCondition,
          hitsPerPage: section?.quantity,
        },
      });
    }
  }

  return productsShowcase;
};

export const parseSections = async ({
  sections,
  taxonomy = {},
  heroCarouselConfig = HERO_CAROUSEL_SLIDES_MAX,
  channel = 'site',
  sectionsConfig = {},
}: TParseSections): Promise<TSections> => {
  const { taxonomyUrl = '', taxonomyName = null, breadcrumb = [] } = taxonomy;
  if (sections) {
    const hasGuideShopSection = sections.some(section =>
      DYNAMIC_GUIDE_SECTION_KEYS.includes(section._modelApiKey)
    );
    const guideShopStores = hasGuideShopSection ? await getAllGuides() : [];

    return sections.reduce(async (prevVal, section) => {
      const prevVal2 = await prevVal;

      if (section._modelApiKey === 'section_showcase') {
        const productsShowcase = await parseProductsShowcase(section, sectionsConfig);

        return [
          ...prevVal2,
          {
            ...section,
            productsData: productsShowcase,
          },
        ];
      }

      if (section._modelApiKey === 'section_carousel') {
        const carouselItemsSite = section.carouselItem
          .filter(item => item.deviceAvailability !== 'app')
          .slice(0, heroCarouselConfig);
        return [...prevVal2, { ...section, carouselItem: carouselItemsSite }];
      }

      if (section._modelApiKey === 'section_product_listing') {
        const fixedAndDefaultFilter = await getServerlessFixedAndDefaultFiltersData({
          preview: false,
          channel,
        });

        return parseProductListing({
          section,
          breadcrumb,
          taxonomyName,
          taxonomyUrl,
          prevVal2,
          fixedAndDefaultFilter,
        });
      }

      if (section._modelApiKey === 'section_guide_search') {
        const totalGuides = guideShopStores.filter(store => store.status === 'Ativa').length;

        return [...prevVal2, { ...section, totalGuides }];
      }

      if (section._modelApiKey === 'section_guide_all_stores_list') {
        return [...prevVal2, { ...section, storesByState: groupStoresByState(guideShopStores) }];
      }

      if (section._modelApiKey === 'section_categories_chip') {
        const categoriesList = section.categoriesList.map(category => ({
          ...category,
          taxonomyFilterParsed: parseTaxonomyFilters(category),
        }));

        return [...prevVal2, { ...section, categoriesList }];
      }

      return [...prevVal2, section];
    }, Promise.resolve([]));
  }

  return [];
};

export const parseHomePageContent = async ({
  homePageConfig,
  homePageContent,
  sections,
}: {
  homePageConfig: any;
  homePageContent?: any;
  sections?: any;
}) => {
  const heroCarouselConfig = parseHomePageConfig(homePageConfig || sections);

  return parseSections({
    sections: homePageContent || sections || [],
    heroCarouselConfig,
  });
};
